var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal is-active" }, [
    _c("div", {
      staticClass: "modal-background",
      on: {
        click: function($event) {
          $event.stopPropagation()
        }
      }
    }),
    _c("div", { staticClass: "modal-card" }, [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [
          _vm._v(
            " " + _vm._s(_vm.step === 1 ? "Personalization" : "Details") + " "
          )
        ])
      ]),
      _c("section", { staticClass: "modal-card-body" }, [
        _c("div", { staticClass: "signup-stepper" }, [
          _c(
            "p",
            { staticClass: "has-text-centered has-text-weight-semibold" },
            [_vm._v(" Step " + _vm._s(_vm.step) + " of 2 ")]
          )
        ]),
        _vm.errorMessage
          ? _c(
              "div",
              {
                staticClass: "notification is-danger is-light",
                class: {
                  "m-fadeIn": _vm.errorMessage,
                  "m-fadeOut": !_vm.errorMessage
                }
              },
              [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]
            )
          : _vm._e(),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.step == 1,
                expression: "step == 1"
              }
            ],
            staticClass: "step-content"
          },
          [
            _c("h4", { staticClass: "title is-5" }, [
              _vm._v("Let's personalize your experience")
            ]),
            _c("p", { staticClass: "subtitle is-6" }, [
              _vm._v(
                " Choose the option that best fits your primary role so we can customize Gobo for your needs. "
              )
            ]),
            _c("div", { staticClass: "user-type-cards" }, [
              _c(
                "div",
                {
                  staticClass: "card user-type-card",
                  class: { "is-selected": _vm.userType === "venue" },
                  on: {
                    click: function($event) {
                      _vm.userType = "venue"
                    }
                  }
                },
                [_vm._m(0)]
              ),
              _c(
                "div",
                {
                  staticClass: "card user-type-card",
                  class: { "is-selected": _vm.userType === "artist" },
                  on: {
                    click: function($event) {
                      _vm.userType = "artist"
                    }
                  }
                },
                [_vm._m(1)]
              ),
              _c(
                "div",
                {
                  staticClass: "card user-type-card",
                  class: { "is-selected": _vm.userType === "festival" },
                  on: {
                    click: function($event) {
                      _vm.userType = "festival"
                    }
                  }
                },
                [_vm._m(2)]
              ),
              _c(
                "div",
                {
                  staticClass: "card user-type-card",
                  class: { "is-selected": _vm.userType === "other" },
                  on: {
                    click: function($event) {
                      _vm.userType = "other"
                    }
                  }
                },
                [_vm._m(3)]
              )
            ])
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.step == 2,
                expression: "step == 2"
              }
            ],
            staticClass: "step-content"
          },
          [
            _vm.userType === "venue"
              ? _c("div", { staticClass: "venue-details" }, [
                  _c("h4", { staticClass: "title is-5" }, [
                    _vm._v("Tell us about your venue")
                  ]),
                  _c("div", { staticClass: "field" }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("Venue Location")
                    ]),
                    _c(
                      "div",
                      { staticClass: "control" },
                      [
                        _c("VenueFinder", {
                          on: { venueFound: _vm.setVenueLocation }
                        })
                      ],
                      1
                    ),
                    _c("p", { staticClass: "help" }, [
                      _vm._v(
                        " Start typing your venue's address to find it using Google Maps "
                      )
                    ])
                  ]),
                  _vm.venueData.location
                    ? _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Venue Capacity")
                        ]),
                        _c("div", { staticClass: "control" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.number",
                                value: _vm.venueData.capacity,
                                expression: "venueData.capacity",
                                modifiers: { number: true }
                              }
                            ],
                            staticClass: "input",
                            attrs: {
                              type: "number",
                              placeholder:
                                "Maximum number of people your venue can hold"
                            },
                            domProps: { value: _vm.venueData.capacity },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.venueData,
                                  "capacity",
                                  _vm._n($event.target.value)
                                )
                              },
                              blur: function($event) {
                                return _vm.$forceUpdate()
                              }
                            }
                          })
                        ])
                      ])
                    : _vm._e(),
                  _vm.venueData.location
                    ? _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Venue Category")
                        ]),
                        _c("div", { staticClass: "control" }, [
                          _c("div", { staticClass: "select is-fullwidth" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.venueData.category,
                                    expression: "venueData.category"
                                  }
                                ],
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.venueData,
                                      "category",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  }
                                }
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v("Select a category")
                                ]),
                                _c("option", { attrs: { value: "music" } }, [
                                  _vm._v("Music Venue")
                                ]),
                                _c(
                                  "option",
                                  { attrs: { value: "performing-arts" } },
                                  [_vm._v(" Performing Arts Theater ")]
                                ),
                                _c("option", { attrs: { value: "comedy" } }, [
                                  _vm._v("Comedy Club")
                                ]),
                                _c(
                                  "option",
                                  { attrs: { value: "multi-use" } },
                                  [_vm._v("Multi-Use Space")]
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    : _vm._e()
                ])
              : _vm._e(),
            _vm.userType === "artist"
              ? _c("div", { staticClass: "artist-details" }, [
                  _c("h4", { staticClass: "title is-5" }, [
                    _vm._v("Tell us about your act")
                  ]),
                  _c("div", { staticClass: "field" }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("Artist or Group Name")
                    ]),
                    _c("div", { staticClass: "control" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.artistData.name,
                            expression: "artistData.name"
                          }
                        ],
                        staticClass: "input",
                        attrs: {
                          type: "text",
                          placeholder: "Your stage name or band name"
                        },
                        domProps: { value: _vm.artistData.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.artistData,
                              "name",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _c("div", { staticClass: "field" }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("Performance Category")
                    ]),
                    _c("div", { staticClass: "control" }, [
                      _c("div", { staticClass: "select is-fullwidth" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.artistData.category,
                                expression: "artistData.category"
                              }
                            ],
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.artistData,
                                  "category",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v("Select a category")
                            ]),
                            _c("option", { attrs: { value: "music" } }, [
                              _vm._v("Music")
                            ]),
                            _c(
                              "option",
                              { attrs: { value: "performing-arts" } },
                              [_vm._v("Performing Arts")]
                            ),
                            _c("option", { attrs: { value: "comedy" } }, [
                              _vm._v("Comedy")
                            ])
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm.artistData.category === "music"
                    ? _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Music Genre")
                        ]),
                        _c("div", { staticClass: "control" }, [
                          _c("div", { staticClass: "select is-fullwidth" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.artistData.genre,
                                    expression: "artistData.genre"
                                  }
                                ],
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.artistData,
                                      "genre",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  }
                                }
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v("Select a genre")
                                ]),
                                _c("option", { attrs: { value: "rock" } }, [
                                  _vm._v("Rock")
                                ]),
                                _c("option", { attrs: { value: "pop" } }, [
                                  _vm._v("Pop")
                                ]),
                                _c("option", { attrs: { value: "jazz" } }, [
                                  _vm._v("Jazz")
                                ]),
                                _c(
                                  "option",
                                  { attrs: { value: "electronic" } },
                                  [_vm._v("Electronic")]
                                ),
                                _c("option", { attrs: { value: "hip-hop" } }, [
                                  _vm._v("Hip-Hop")
                                ]),
                                _c("option", { attrs: { value: "country" } }, [
                                  _vm._v("Country")
                                ]),
                                _c("option", { attrs: { value: "folk" } }, [
                                  _vm._v("Folk")
                                ]),
                                _c(
                                  "option",
                                  { attrs: { value: "classical" } },
                                  [_vm._v("Classical")]
                                ),
                                _c("option", { attrs: { value: "other" } }, [
                                  _vm._v("Other")
                                ])
                              ]
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm.artistData.category === "performing-arts"
                    ? _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Performing Arts Genre")
                        ]),
                        _c("div", { staticClass: "control" }, [
                          _c("div", { staticClass: "select is-fullwidth" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.artistData.genre,
                                    expression: "artistData.genre"
                                  }
                                ],
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.artistData,
                                      "genre",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  }
                                }
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v("Select a genre")
                                ]),
                                _c("option", { attrs: { value: "theater" } }, [
                                  _vm._v("Theater")
                                ]),
                                _c("option", { attrs: { value: "dance" } }, [
                                  _vm._v("Dance")
                                ]),
                                _c("option", { attrs: { value: "opera" } }, [
                                  _vm._v("Opera")
                                ]),
                                _c("option", { attrs: { value: "ballet" } }, [
                                  _vm._v("Ballet")
                                ]),
                                _c(
                                  "option",
                                  { attrs: { value: "musical-theater" } },
                                  [_vm._v("Musical Theater")]
                                ),
                                _c(
                                  "option",
                                  { attrs: { value: "spoken-word" } },
                                  [_vm._v("Spoken Word")]
                                ),
                                _c("option", { attrs: { value: "improv" } }, [
                                  _vm._v("Improv")
                                ]),
                                _c("option", { attrs: { value: "magic" } }, [
                                  _vm._v("Magic")
                                ]),
                                _c("option", { attrs: { value: "other" } }, [
                                  _vm._v("Other")
                                ])
                              ]
                            )
                          ])
                        ])
                      ])
                    : _vm._e()
                ])
              : _vm._e(),
            _vm.userType === "festival"
              ? _c("div", { staticClass: "festival-details" }, [
                  _c("h4", { staticClass: "title is-5" }, [
                    _vm._v("Tell us about your festival")
                  ]),
                  _c("div", { staticClass: "field" }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("Festival Name")
                    ]),
                    _c("div", { staticClass: "control" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.festivalData.name,
                            expression: "festivalData.name"
                          }
                        ],
                        staticClass: "input",
                        attrs: {
                          type: "text",
                          placeholder: "Name of your festival or event series"
                        },
                        domProps: { value: _vm.festivalData.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.festivalData,
                              "name",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _c("div", { staticClass: "field" }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("Festival Location")
                    ]),
                    _c("div", { staticClass: "control" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.festivalData.location,
                            expression: "festivalData.location"
                          }
                        ],
                        staticClass: "input",
                        attrs: {
                          type: "text",
                          placeholder:
                            "City, State/Province (e.g., Minneapolis, MN)"
                        },
                        domProps: { value: _vm.festivalData.location },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.festivalData,
                              "location",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _c("p", { staticClass: "help" }, [
                      _vm._v("Where does your festival typically take place?")
                    ])
                  ]),
                  _vm.festivalData.location
                    ? _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Frequency")
                        ]),
                        _c("div", { staticClass: "control" }, [
                          _c("div", { staticClass: "select is-fullwidth" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.festivalData.frequency,
                                    expression: "festivalData.frequency"
                                  }
                                ],
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.festivalData,
                                      "frequency",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  }
                                }
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v("How often does this festival happen?")
                                ]),
                                _c("option", { attrs: { value: "annual" } }, [
                                  _vm._v("Annual")
                                ]),
                                _c(
                                  "option",
                                  { attrs: { value: "semi-annual" } },
                                  [_vm._v(" Semi-Annual (twice a year) ")]
                                ),
                                _c(
                                  "option",
                                  { attrs: { value: "quarterly" } },
                                  [_vm._v("Quarterly")]
                                ),
                                _c("option", { attrs: { value: "monthly" } }, [
                                  _vm._v("Monthly")
                                ]),
                                _c("option", { attrs: { value: "one-time" } }, [
                                  _vm._v("One-time event")
                                ]),
                                _c(
                                  "option",
                                  { attrs: { value: "irregular" } },
                                  [_vm._v("Irregular schedule")]
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm.festivalData.location
                    ? _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Primary Focus")
                        ]),
                        _c("div", { staticClass: "control" }, [
                          _c("div", { staticClass: "select is-fullwidth" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.festivalData.primaryFocus,
                                    expression: "festivalData.primaryFocus"
                                  }
                                ],
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.festivalData,
                                      "primaryFocus",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  }
                                }
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v(
                                    " Select the primary focus of your festival "
                                  )
                                ]),
                                _c("option", { attrs: { value: "music" } }, [
                                  _vm._v("Music")
                                ]),
                                _c("option", { attrs: { value: "comedy" } }, [
                                  _vm._v("Comedy")
                                ]),
                                _c("option", { attrs: { value: "theater" } }, [
                                  _vm._v("Theater")
                                ]),
                                _c("option", { attrs: { value: "film" } }, [
                                  _vm._v("Film")
                                ]),
                                _c(
                                  "option",
                                  { attrs: { value: "multi-genre" } },
                                  [_vm._v("Multi-Genre")]
                                ),
                                _c("option", { attrs: { value: "other" } }, [
                                  _vm._v("Other")
                                ])
                              ]
                            )
                          ])
                        ])
                      ])
                    : _vm._e()
                ])
              : _vm._e(),
            _vm.userType === "other"
              ? _c("div", { staticClass: "other-details" }, [
                  _c("h4", { staticClass: "title is-5" }, [
                    _vm._v("Tell us about the events you organize")
                  ]),
                  _c("div", { staticClass: "field" }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("Event Description")
                    ]),
                    _c("div", { staticClass: "control" }, [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.otherData.description,
                            expression: "otherData.description"
                          }
                        ],
                        staticClass: "textarea",
                        attrs: {
                          placeholder:
                            "Describe the types of events you create and organize",
                          rows: "4"
                        },
                        domProps: { value: _vm.otherData.description },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.otherData,
                              "description",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _c("p", { staticClass: "help" }, [
                      _vm._v(
                        " Help us understand what kinds of events you organize so we can better tailor Gobo to your needs. "
                      )
                    ])
                  ])
                ])
              : _vm._e()
          ]
        )
      ]),
      _c("footer", { staticClass: "modal-card-foot" }, [
        _vm.step > 1
          ? _c(
              "button",
              { staticClass: "button", on: { click: _vm.previousStep } },
              [_vm._v(" Back ")]
            )
          : _vm._e(),
        _c(
          "button",
          {
            staticClass: "button is-primary",
            attrs: { disabled: !_vm.canProceed },
            on: { click: _vm.nextStep }
          },
          [_vm._v(" " + _vm._s(_vm.step === 1 ? "Next" : "Get Started") + " ")]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-content" }, [
      _c("div", { staticClass: "media" }, [
        _c("div", { staticClass: "media-left" }, [
          _c("span", { staticClass: "icon is-large" }, [
            _c("i", { staticClass: "fas fa-building fa-2x" })
          ])
        ]),
        _c("div", { staticClass: "media-content" }, [
          _c("p", { staticClass: "title is-6" }, [_vm._v("Venue Manager")]),
          _c("p", { staticClass: "subtitle is-7" }, [
            _vm._v(" I manage a physical location that hosts performances ")
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-content" }, [
      _c("div", { staticClass: "media" }, [
        _c("div", { staticClass: "media-left" }, [
          _c("span", { staticClass: "icon is-large" }, [
            _c("i", { staticClass: "fas fa-music fa-2x" })
          ])
        ]),
        _c("div", { staticClass: "media-content" }, [
          _c("p", { staticClass: "title is-6" }, [_vm._v("Artist/Performer")]),
          _c("p", { staticClass: "subtitle is-7" }, [
            _vm._v(
              " I'm a musician, comedian, theater performer, or entertainer "
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-content" }, [
      _c("div", { staticClass: "media" }, [
        _c("div", { staticClass: "media-left" }, [
          _c("span", { staticClass: "icon is-large" }, [
            _c("i", { staticClass: "fas fa-calendar-alt fa-2x" })
          ])
        ]),
        _c("div", { staticClass: "media-content" }, [
          _c("p", { staticClass: "title is-6" }, [
            _vm._v("Festival Organizer")
          ]),
          _c("p", { staticClass: "subtitle is-7" }, [
            _vm._v(
              " I organize festivals or recurring events with multiple artists "
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-content" }, [
      _c("div", { staticClass: "media" }, [
        _c("div", { staticClass: "media-left" }, [
          _c("span", { staticClass: "icon is-large" }, [
            _c("i", { staticClass: "fas fa-users fa-2x" })
          ])
        ]),
        _c("div", { staticClass: "media-content" }, [
          _c("p", { staticClass: "title is-6" }, [
            _vm._v("Other Event Organizer")
          ]),
          _c("p", { staticClass: "subtitle is-7" }, [
            _vm._v(" I organize events that don't fit the above ")
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }